import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import { Read } from '../Editor'
import './styles/styles.css'

import { useSelector } from 'react-redux'
import { setUserManually } from 'store/EmployeeReport/actions'
import { changeScore, saveGrade, setGradedQuestions } from 'store/Quiz/actions'
import GridQuestions from '../LearningPlan/Course/components/GridQuestions'

const InputCheckbox = (props) => (
  <input
    type='checkbox'
    name={'name' + props.item.id}
    value={props.item.id}
    id={props.item.id}
    checked={props.item.selected}
    disabled={props.disabled}
    onChange={() => props.onChangeCheckbox(props.index)}
    className='answer-input'
  />
)

const InputRadio = (props) => (
  <input
    type='radio'
    name={'name-' + props.question.id}
    value={props.item.id}
    id={props.item.id}
    checked={props.item.selected || false}
    disabled={props.disabled}
    onChange={() => props.onChange(props.index)}
    className='answer-input'
  />
)
const SubmissionHeader = (props) => {
  const quizScores = props.submission.quiz_score || 0
  const quizTotalPoints = props.submission.quiz
    ? props.submission.quiz
        .map((item) => parseInt(item.points))
        .reduce((total, value) => total + value) || 0
    : null

  let language = props.language ? props.language : {}

  return (
    <div>
      <div>
        <div style={{ textAlign: 'right' }}>
          <span className='user-points'>
            {language.courses ? language.courses.total_points : null}:{' '}
            {quizScores} / {quizTotalPoints}
          </span>
        </div>
      </div>
      {/* <div className='col-md-4 right-aligned submission-footer'>
				<span className='user-points'>{language.courses ? language.courses.total_points : null}: {quizScores} / {quizTotalPoints}
				</span>
			</div> */}
    </div>
  )
}

const Question = (props) => {
  let language = props.language ? props.language : {}
  const dispatch = useDispatch()

  const { gradedQuestions } = useSelector((store) => store.quizes)

  useEffect(() => {
    if (props?.allQuestions && props?.allQuestions?.length) {
      dispatch(setGradedQuestions(props.allQuestions))
    }
  }, [dispatch, props.allQuestions])

  const scoreEntry = props.gridScores.find(
    (item) => item[props.id] !== undefined
  )
  const gridScore = scoreEntry ? scoreEntry[props.id] : 0

  return (
    <div className='col-md-12 quiz-space-bottom'>
      <div className='row'>
        <div className='col-md-12'>
          <div className='quiz-row-wrapper'>
            <span className='question-points'>
              {[7].includes(props.type) && props.courseStatus === 6 ? (
                <b>
                  {language.courses ? language.courses.points : null}:{' '}
                  <input
                    defaultValue={props.score}
                    type='number'
                    min={0}
                    max={props.points}
                    onChange={(e) => {
                      dispatch(changeScore(props.index, e.target.value))
                    }}
                  />{' '}
                  / {props.points}
                </b>
              ) : (
                <>
                  <b>
                    {language.courses ? language.courses.points : null}:{' '}
                    {props.type === 8 && props.courseStatus === 6
                      ? gridScore
                      : props.score}{' '}
                    / {props.points}
                  </b>
                </>
              )}
            </span>
            {/* <span className='question-points'>
                        <b>{ props.points }</b>
                    </span> */}
          </div>
        </div>
      </div>
      <div className='row'>
        <div className='col-md-12'>
          <div className='quiz-row-wrapper richEditorStyles'>
            <Read content={props.name} />
          </div>
        </div>
      </div>
      <div className='quiz-row-wrapper'>{props.children}</div>
    </div>
  )
}

const Submission = (props) => {
  let optionDescription = null
  const [gridScores, setGridScores] = useState([])

  const questions = props.submission.quiz ? props.submission.quiz : null
  const openResponseQuestionsExist = questions.some((question) =>
    [7, 8].includes(question.type)
  )
  const gridQuestionsExist = questions.some((question) => question.type === 8)

  const courseStatus = props?.currentSubmission?.user_progress_status

  const dispatch = useDispatch()
  const { employeeId, user } = useSelector((store) => store.employeeReport)

  useEffect(() => {
    if (!props?.user?.id && employeeId) {
      dispatch(setUserManually(employeeId))
    }
  }, [dispatch, employeeId, props?.user?.id])

  useEffect(() => {
    if (!openResponseQuestionsExist) return
    const gridQuestions = questions
      ?.filter((q) => q.type === 8)
      ?.map((q) => {
        return { [q.id]: 0 }
      })

    setGridScores(gridQuestions)
  }, [openResponseQuestionsExist, questions])

  return (
    <div className='row'>
      {questions
        ? questions.map((question, index) => (
            <Question
              {...question}
              isSubmission={props.isSubmission}
              quizPassed={props.quizPassed}
              key={index}
              index={index}
              language={props.language}
              allQuestions={props.submission.questions}
              courseStatus={courseStatus}
              setGridScores={setGridScores}
              gridScores={gridScores}
            >
              {(() => {
                return (question.options || []).map((optionItem, optionIndex) =>
                  question.type !== 5 && question.type !== 8 ? (
                    <div
                      key={`${question.id}-${optionIndex}`}
                      className='question-row'
                    >
                      {question.type === 3 ? (
                        <InputCheckbox
                          {...props}
                          question={question}
                          item={optionItem}
                          index={optionIndex}
                          disabled
                        />
                      ) : question.type === 4 ? null : (
                        <InputRadio
                          {...props}
                          question={question}
                          item={optionItem}
                          index={optionIndex}
                          disabled
                        />
                      )}
                      {question.type !== 5 ? (
                        question.type === 6 ? (
                          <span className='image-option-wrapper'>
                            <img
                              alt='leon'
                              className={`submitted-image-option ${
                                optionItem.selected
                                  ? 'image-option-selected'
                                  : ''
                              }`}
                              src={`${optionItem.url ? optionItem.url : ''}`}
                            />
                          </span>
                        ) : (
                          <label htmlFor={optionItem.id}>
                            {optionItem.name}
                          </label>
                        )
                      ) : null}
                      {(() => {
                        if (!props.quizPassed) {
                          if (
                            question.type === 1 ||
                            question.type === 2 ||
                            question.type === 6
                          ) {
                            if (
                              optionItem.selected === true &&
                              optionItem.id == question.correct_answer
                            ) {
                              return (
                                <FontAwesomeIcon
                                  icon='check'
                                  className='icon icon-answ-correct'
                                />
                              )
                            } else if (optionItem.selected) {
                              return (
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className='icon icon-answ-incorrect'
                                />
                              )
                            }
                          } else if (question.type === 3) {
                            if (
                              optionItem.selected &&
                              optionItem.id === optionItem.correct_answer
                            ) {
                              return (
                                <FontAwesomeIcon
                                  icon='check'
                                  className='icon icon-answ-correct'
                                />
                              )
                            } else if (optionItem.selected) {
                              return (
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className='icon icon-answ-incorrect'
                                />
                              )
                            }
                          }
                        }
                      })()}

                      {(() => {
                        if (question.type === 1 && props.quizPassed) {
                          if (props.quizPassed === -1) {
                            if (question.answered && optionItem.selected) {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon='check'
                                    className='icon icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          } else if (props.quizPassed === 1) {
                            if (question.answered) {
                              if (question.answeredCorrect) {
                                if (optionItem.correct) {
                                  return (
                                    <FontAwesomeIcon
                                      icon='check'
                                      className='icon icon-answ-correct'
                                    />
                                  )
                                }
                              } else if (
                                optionItem.correct &&
                                !optionItem.selected
                              ) {
                                return (
                                  <FontAwesomeIcon
                                    icon='check'
                                    className='icon icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          }
                        }
                      })()}

                      {(() => {
                        if (
                          question.type === 2 ||
                          (question.type === 6 && props.quizPassed)
                        ) {
                          if (props.quizPassed === -1) {
                            if (question.answered && optionItem.selected) {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon='check'
                                    className='icon icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          } else if (props.quizPassed === 1) {
                            if (question.answered) {
                              if (question.answeredCorrect) {
                                if (optionItem.correct) {
                                  return (
                                    <FontAwesomeIcon
                                      icon='check'
                                      className='icon icon-answ-correct'
                                    />
                                  )
                                }
                              } else if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon='check'
                                    className='icon icon-answ-correct'
                                  />
                                )
                              } else if (
                                !optionItem.correct &&
                                optionItem.selected
                              ) {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          }
                        }
                      })()}

                      {(() => {
                        if (question.type === 3 && props.quizPassed) {
                          if (props.quizPassed === -1) {
                            if (optionItem.answered) {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon='check'
                                    className='icon icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          } else if (props.quizPassed === 1) {
                            if (!optionItem.answered) {
                              if (optionItem.correct) {
                                return (
                                  <span>
                                    <FontAwesomeIcon
                                      icon={faTimes}
                                      className='icon icon-answ-incorrect'
                                    />
                                    <label className='hint-text'>
                                      Not selected
                                    </label>
                                  </span>
                                )
                              }
                            } else {
                              if (optionItem.correct) {
                                return (
                                  <FontAwesomeIcon
                                    icon='check'
                                    className='icon icon-answ-correct'
                                  />
                                )
                              } else {
                                return (
                                  <FontAwesomeIcon
                                    icon={faTimes}
                                    className='icon icon-answ-incorrect'
                                  />
                                )
                              }
                            }
                          }
                        }
                      })()}

                      {question.type === 4 ? (
                        question.correctAnswer &&
                        optionItem.id ===
                          question.correctAnswer[optionIndex].id ? (
                          <FontAwesomeIcon
                            icon='check'
                            className='icon icon-answ-correct'
                          />
                        ) : (
                          <FontAwesomeIcon
                            icon={faTimes}
                            className='icon icon-answ-incorrect'
                          />
                        )
                      ) : null}
                      {(() => {
                        if (
                          [1, 2].includes(question.type) &&
                          question.answered &&
                          optionItem.selected
                        ) {
                          optionDescription = optionItem.description
                            ? optionItem.description
                            : null
                        }
                      })()}
                      {[1, 2].includes(question.type) &&
                      question.answered &&
                      optionItem.selected &&
                      optionDescription ? (
                        <div className='option-feedback'>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: optionDescription,
                            }}
                          />
                          <FontAwesomeIcon
                            icon='info-circle'
                            className='info-icon'
                          />
                        </div>
                      ) : null}
                    </div>
                  ) : optionItem && optionItem.type === 1 ? (
                    <div
                      key={`${question.id}-${optionIndex}`}
                      className='question-row'
                    >
                      <div className='col-xl-6 matching-options-wrapper'>
                        <div className='matching-options-container'>
                          <label htmlFor={optionItem.id}>
                            {optionItem.name}
                          </label>
                          {(() => {
                            const answer = question.options.find(
                              (item) => item.id === optionItem.selected
                            )

                            return answer ? (
                              <label htmlFor={optionItem.id}>
                                {answer.name}
                              </label>
                            ) : (
                              <label className='hint-text'>
                                No option selected
                              </label>
                            )
                          })()}
                          {(() => {
                            const answer = question.options.find(
                              (item) => item.id === optionItem.selected
                            )

                            return optionItem.selected &&
                              optionItem.id === answer.match &&
                              optionItem.selected === answer.id ? (
                              <FontAwesomeIcon
                                icon='check'
                                className='icon icon-answ-correct'
                              />
                            ) : optionItem.selected ? (
                              <FontAwesomeIcon
                                icon={faTimes}
                                className='icon icon-answ-incorrect'
                              />
                            ) : null
                          })()}
                        </div>
                      </div>
                    </div>
                  ) : null
                )
              })()}
              {question.type === 7 && <p>{question.answer}</p>}
              {question.type === 8 && (
                <GridQuestions
                  editMode={false}
                  viewMode={true}
                  tableData={question.tableData}
                  gradingMode={courseStatus === 6}
                  questionPoints={question.points}
                  setGridScores={setGridScores}
                  questionId={question.id}
                  gradedScores={question.scores}
                />
              )}
            </Question>
          ))
        : null}

      {openResponseQuestionsExist && courseStatus === 6 && (
        <button
          onClick={() => {
            if (gridQuestionsExist) {
              questions.forEach((question, index) => {
                if (question.type === 8) {
                  const scoreEntry = gridScores.find(
                    (item) => item[question.id] !== undefined
                  )
                  const gridScore = scoreEntry ? scoreEntry[question.id] : 0
                  dispatch(changeScore(index, gridScore))
                }
              })
            }
            dispatch(saveGrade(props.currentSubmission.course_id, user))
            props.toggle()
            // setTimeout(() => {
            //   window.location.reload()
            // }, 100)
          }}
          className='btn btn-info mx-2'
        >
          Save
        </button>
      )}
    </div>
  )
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const dispatch = useDispatch()

  let language = props.language ? props.language : {}

  const handleToggle = () => {
    dispatch(props.setHideSubmissionData())
  }

  return (
    <Modal
      isOpen={props.isShowing}
      toggle={handleToggle}
      size={'xl'}
      centered
      height={true}
      keyboard={true}
      fade={true}
      // title={language.courses ? language.courses.submission : null}
    >
      {/* <Overlay> */}
      {/* <Header> */}
      <ModalHeader className='border-bottom pb-2' toggle={handleToggle}>
        {language.courses ? language.courses.submission : null}
      </ModalHeader>
      {/* </Header> */}

      {/* <Content> */}
      <ModalBody>
        <SubmissionHeader {...props} language={props.language} />
        <Submission
          {...props}
          language={props.language}
          toggle={handleToggle}
        />
      </ModalBody>
      {/* </Content> */}
      {/* </Overlay> */}
    </Modal>
  )
}
